import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import './clubcard.scss';

@Component({
  template: `
<div class="clubcard-real" :class="type">
  <div class="clubcard-content" :class="{ active: !zoom }">
    <template v-if="type == 'newworld'">
      <div class="clubcard-name">YOUR NAME</div>
      <div class="clubcard-number">6014 3555 1234 5678</div>
      <div class="clubcard-number-zoom" v-if="zoom">5678</div>
    </template>
  </div>
</div>
`
})
export class ClubCardComponent extends Vue {
  @Prop
  zoom: boolean;

  @Prop({ default: 'newworld' })
  type: string;
}

Vue.component('clubcard', ClubCardComponent);



// WEBPACK FOOTER //
// ./src/components/clubcard/clubcard.ts